import { Uploadstate } from './../models/uploadstate';
import { Observable } from 'rxjs/Rx';
import { Folder } from './../models/folder';
import { AuthService } from './auth.service';
import { FileItem } from './../directives/file-item.directive';
import { Upload } from './upload';
import { Injectable } from '@angular/core';
import {asObservable} from "./asObservable";
import { BehaviorSubject } from 'rxjs/Rx';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import * as firebase from 'firebase';
import * as _ from 'lodash';


@Injectable()
export class UploadService {

  private IMAGES_FOLDER: string = 'uploads';

  public _progression : BehaviorSubject<Uploadstate> = new BehaviorSubject({progress:0,total:0,left:0,uploading:false});

  constructor(private db: AngularFireDatabase,public auth: AuthService) { }

  private basePath:string = '/uploads';

  uploads: FirebaseListObservable<Upload[]>;

  getPictures(){
  //const queryList =
  return this.db.list('/uploads', {
    query: {
      limitToLast: 20,
      orderByKey: true
    }
  }) as FirebaseListObservable<Upload[]>;
    //return this.db.list('/uploads') as FirebaseListObservable<Upload[]>;
  }


  getUploads(query={}) {
    this.uploads = this.db.list(this.basePath, {
      query: query
    });
    return this.uploads
  }


  deleteUpload(upload: Upload) {
    this.deleteFileData(upload.$key)
    .then( () => {
      this.deleteFileStorage(upload.name)
    })
    .catch(error => console.log(error))
  }
  // Writes the file details to the realtime db
  private saveFileData(upload: Upload, folder: Folder, company: string) {
    this.db.list(`${this.basePath}/${company}/${folder.folderUid}/files/`).push(upload);
  }
  // Writes the file details to the realtime db
  private deleteFileData(key: string) {
    return this.db.list(`${this.basePath}/`).remove(key);
  }
  // Firebase files must have unique names in their respective storage dir
  // So the name serves as a unique key
  private deleteFileStorage(name:string) {
    const storageRef = firebase.storage().ref();
    storageRef.child(`${this.basePath}/${name}`).delete()
  }

  uploadImagesToFirebase(files: Array<FileItem[]>,folder:Folder, company:string) {
    let storageRef = firebase.storage().ref();
    this.db.list(`${this.basePath}/${company}/folder/`).update(folder.folderUid, folder);
    _.each(files, (item:FileItem) => {
      item.isUploading = true;
      let uploadTask: firebase.storage.UploadTask = storageRef.child(`${this.IMAGES_FOLDER}/${company}/${folder.folderUid}/${item.file.name}`).put(item.file);
    //  let snap = snapshot as firebase.storage.UploadTaskSnapshot
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          let snap = snapshot as firebase.storage.UploadTaskSnapshot
          item.progress = (snap.bytesTransferred / snap.totalBytes) * 100;
         // item.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {},
        () => {
          item.url = uploadTask.snapshot.downloadURL;
          item.isUploading = false;
          let dbUpload =  new Upload(item,this.auth.displayUser);
          this.saveFileData(dbUpload,folder, company);
        }
      );
    });
 }

 getProgression(){
  return asObservable( this._progression);
}

 uploadRawImagesToFirebase(files: any,fUid:string, company:string) {
    let storageRef = firebase.storage().ref();
    let i = files.length;
    _.each(files, (item:FileItem) => {
    item.isUploading = true;
    console.log('En chargement ', item)
    let uploadTask: firebase.storage.UploadTask = storageRef.child(`${this.IMAGES_FOLDER}/${company}/${fUid}/${item.name}`).put(item);
  //  let snap = snapshot as firebase.storage.UploadTaskSnapshot
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        let snap = snapshot as firebase.storage.UploadTaskSnapshot
        item.progress = (snap.bytesTransferred / snap.totalBytes) * 100;
        this._progression.next({progress: item.progress, total: i, left: 1 , uploading: true});
        },
      (error) => {},
      () => {
        item.isUploading = false;
        i -=1;
        this._progression.next({progress: 0, total: i, left: 0});
      }
    );
  });
  this._progression.next({progress: 0, total: i, left: 0,uploading:false});
}

 private saveImage(image:any) {
  this.db.list(`/${this.IMAGES_FOLDER}`).push(image);
}

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/upload.service.ts